export const PDF_PRINT_PRESET = "preset";
export const PDF_PRINT_VISIBILITY = "v";
export const PDF_USE_BORDERS = "b";
export const SHARE_SETTINGS = "s";
export const PDF_SHOW_PRICES = "p";